const SITE_NAME = 'Usuario UNC';
const OG_IMAGE_PATH = '/og-usuario-unc.png';

const PUBLIC_ROUTES = [
    {
        path: '/',
        label: 'Inicio',
        title: 'Usuario UNC - Universidad Nacional de Córdoba',
        description: 'Creá tu Usuario UNC y accedé con un solo usuario y contraseña a Guaraní, GDE, Portal del Empleado y todos los servicios digitales de la UNC.',
        changefreq: 'monthly',
        priority: '1.0',
    },
    {
        path: '/registro',
        label: 'Crear Usuario UNC',
        title: 'Usuario UNC | Registro',
        description: 'Creá tu Usuario UNC en cuatro pasos: ingresá tu documento, elegí tu rol, verificá tus datos y definí tu nombre de usuario y contraseña.',
        changefreq: 'monthly',
        priority: '0.9',
    },
    {
        path: '/recuperar-clave',
        label: 'Recuperar contraseña',
        title: 'Usuario UNC | Recuperar contraseña',
        description: '¿Olvidaste tu contraseña? Ingresá tu Usuario UNC (@unc.edu.ar o @mi.unc.edu.ar) y te enviamos las instrucciones para recuperarla.',
        changefreq: 'monthly',
        priority: '0.8',
    },
    {
        path: '/contactos',
        label: 'Contactos',
        title: 'Usuario UNC | Contactos',
        description: 'Encontrá el correo del administrador de Usuario UNC de tu facultad o dependencia de la UNC para resolver cualquier problema con tu cuenta.',
        changefreq: 'monthly',
        priority: '0.8',
    },
    {
        path: '/preguntas-frecuentes',
        label: 'Preguntas frecuentes',
        title: 'Usuario UNC | Preguntas frecuentes',
        description: 'Respuestas a las dudas más comunes sobre cómo crear, recuperar y usar tu Usuario UNC en la Universidad Nacional de Córdoba.',
        changefreq: 'weekly',
        priority: '0.9',
    },
];

// Llevan un token personal enviado por correo: no se indexan ni se rastrean.
const TOKEN_ROUTES = [
    {
        prefix: '/registro-usuario',
        title: 'Usuario UNC | Registro',
        description: 'Último paso para crear tu Usuario UNC.',
    },
    {
        prefix: '/nueva-clave',
        title: 'Usuario UNC | Cambiar contraseña',
        description: 'Creá una contraseña nueva para tu Usuario UNC.',
    },
    {
        prefix: '/confirmar-correo',
        title: 'Usuario UNC | Confirmar correo',
        description: 'Verificación del correo asociado a tu Usuario UNC.',
    },
    {
        prefix: '/cambiar-correo-recuperacion',
        title: 'Usuario UNC | Confirmar correo de recuperación',
        description: 'Actualización del correo de recuperación de tu Usuario UNC.',
    },
];

const NOT_FOUND_META = {
    path: null,
    title: 'Usuario UNC | Página no encontrada',
    description: 'La página que buscabas no existe o el enlace está desactualizado.',
    indexable: false,
    status: 404,
};

function normalizePath (pathname) {
    const withoutTrailing = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    return (withoutTrailing || '/').toLowerCase();
}

function matchRoute (pathname) {
    const path = normalizePath(pathname || '/');

    const publicRoute = PUBLIC_ROUTES.find(route => route.path === path);
    if (publicRoute) {
        return { ...publicRoute, indexable: true, status: 200 };
    }

    const tokenRoute = TOKEN_ROUTES.find(({ prefix }) => new RegExp(`^${prefix}(/[^/]+)?$`).test(path));
    if (tokenRoute) {
        // Sin path, para no publicar la URL con el token en la canonical ni en og:url.
        return { path: null, title: tokenRoute.title, description: tokenRoute.description, indexable: false, status: 200 };
    }

    return NOT_FOUND_META;
}

function absoluteUrl (baseUrl, routePath) {
    return routePath ? `${baseUrl}${routePath}` : null;
}

function robotsContent (indexable) {
    return indexable ? 'index, follow, max-image-preview:large, max-snippet:-1' : 'noindex, nofollow';
}

module.exports = {
    SITE_NAME,
    OG_IMAGE_PATH,
    PUBLIC_ROUTES,
    TOKEN_ROUTES,
    matchRoute,
    absoluteUrl,
    robotsContent,
};
